import apiClient from '../../../apis/portaliref';
import { portaleApi } from '../../../helpers/portaleModuleHelper';

const api = portaleApi('camera', apiClient, {
    // const api = portaleApi('photoGalleries', apiClient, {
    // top: 'perPage',
    per_page: 'perPage',
    page: 'page',
    nome: 'q',
    anagrafica: 'ao_hotel_id'
});

api.editCamera = (id, data) => {
    return apiClient({
        url: `camera/${id}`,
        method: 'patch',
        data,
    });
};

export default api;
